import React from 'react'
import Store from './src/Store'
import './static/fonts/fellix/stylesheet.css'
import './static/fonts/nib/stylesheet.css'
import Providers from './src/components/ReformProviders/Providers'

export const wrapRootElement = ({ element }) => <Providers><Store>{element}</Store></Providers>
